import { call, put, select } from "redux-saga/effects";

import actions from "@/actions";
import { Api } from "@/utils";

import saveLightGroups from "./save-light-groups";

const config = {
    text: {
        saving: "Saving settings...",
        saveError: "Failed to save settings",
        success: "Settings saved successfully",
    },
};

/**
 * Saves the pending light group settings to the API.
 *
 * @returns The save result.
 * @yields Calls the API and dispatches settings updates.
 */
function* saveLightGroupSettings() {
    yield put(
        actions.map.general.setLightGroupSettingsStatus({
            message: config.text.saving,
        }),
    );

    const { groupGeometries, lightGroups, site } = yield select(({ map }) => ({
        groupGeometries: map.values.global.present.groupGeometries,
        lightGroups: map.general.lightGroups,
        site: map.general.site,
    }));

    yield call(saveLightGroups, {
        siteId: site.siteID,
        groupGeometries,
        lightGroups,
    });

    const payload = yield select(
        ({ map }) => map.general.pendingLightGroupSettings,
    );
    const route = "v1/control-group-settings";
    const { result } = yield call(
        Api.put,
        route,
        [payload],
        {},
        { parseErrorBody: true },
    );

    return result[0];
}

/**
 * Saves light group settings without publishing, updating the store and status on success or failure.
 *
 * @yields Calls the save API and dispatches status updates.
 */
function* onlySaveLightGroupSettings() {
    try {
        const settings = yield call(saveLightGroupSettings);
        yield put(actions.map.general.putLightGroupSettings(settings));

        yield put(
            actions.map.general.setLightGroupSettingsStatus({
                message: config.text.success,
                success: true,
            }),
        );
    } catch (err) {
        let message = err.cause?.errorBody?.msg;

        if (!message) {
            message = config.text.saveError;
        }

        yield put(
            actions.map.general.setLightGroupSettingsStatus({
                message,
                success: false,
            }),
        );
    } finally {
        yield put(actions.map.general.clearPendingLightGroupSettings());
    }
}

export { onlySaveLightGroupSettings, saveLightGroupSettings };
